import { forwardRef, useId, type TextareaHTMLAttributes } from 'react'
import { cn } from '@/internationalization/cn'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  hint?: string
  error?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, error, className, id, rows = 4, ...props },
  ref,
) {
  const autoId = useId()
  const textareaId = id ?? autoId
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={textareaId} className="mb-1.5 block text-sm font-medium text-fg">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={textareaId}
        rows={rows}
        aria-invalid={error ? true : undefined}
        className={cn(
          'w-full resize-y rounded-md border border-border bg-surface px-3 py-2 text-base text-fg',
          'placeholder:text-fg-subtle transition-colors duration-fast hover:border-border-strong',
          error && 'border-danger',
          className,
        )}
        {...props}
      />
      {(error || hint) && (
        <p className={cn('mt-1.5 text-sm', error ? 'text-danger' : 'text-fg-subtle')}>{error ?? hint}</p>
      )}
    </div>
  )
})
